<h1 class="title">Admin Overview</h1>
<h5>A high-level overview of assets, projects, people, and information</h5>
<acabim-admin-onboarding></acabim-admin-onboarding>
<div class="cas-flex-row">
    <div class="p-col-12">
        <acabim-card cardHeading="Projects/buildings by sites"
            [cardContent]="chartCard"
            [isCollapsed]="false"
            [isCollapsible]="true"
            [hasHelpButton]="true"
            [helpMessage]="'See this video guide on working in the Admin Space'"
            [extLinkUrl] = "'https://cas.net.nz/admin'"
            [linkText]="'Guide to Admin Space'"
        >
        </acabim-card>
    </div>
    <div class="p-col-12">
        <p-tabView orientation="right">
            <p-tabPanel header="Projects">
                <ng-template pTemplate="content">
                    <acabim-admin-dashboard-projects></acabim-admin-dashboard-projects>
                </ng-template>
            </p-tabPanel>
            <p-tabPanel header="No. of people by user type">
                <ng-template pTemplate="content">
                    <acabim-admin-user-type-stats></acabim-admin-user-type-stats>
                </ng-template>
            </p-tabPanel>
        </p-tabView>
    </div>
</div>


<ng-template #chartCard>
    <div class="cas-flex-row">
        <div class="p-col-6">
            <acabim-admin-site-related-stats #charts></acabim-admin-site-related-stats>

        </div>
        <div class="p-col-6">
            <acabim-admin-project-building-status></acabim-admin-project-building-status>
        </div>
    </div>
</ng-template>
